import { AppStateFailure, IStateSlice } from '@symphony-solo/shared/common-state/src';
import { TaxrateDto } from '../dtos';

export class TaxrateState implements IStateSlice {
  public isLoading: boolean;
  public failures: AppStateFailure;
  public taxrates: { [taxrateId: number]: TaxrateDto };

  constructor() {
    this.isLoading = false;
    this.failures = null;
    this.taxrates = null;
  }
}
